import { Blockchain } from "@rarible/api-client"
import { polygon } from "viem/chains"
import { toCurrencyId } from "../../../price/types"
import { FEE_CONFIG_URL } from "../constants"
import type { StaticEthereumBlockchainConfig } from "../types"

export const polygonConfig: StaticEthereumBlockchainConfig = {
  name: polygon.name,
  icon: "/images/blockchains/polygon.svg",
  isEvm: true,
  testnet: false,
  isTestnet: false,
  feesVersion: "v3",
  treasury: "0x64d34BcfC32Fb663172C47d6E4Fb1dBFaba6e7a2",
  unionApi: "https://api.rarible.org",
  basePath: "https://polygon-api.rarible.org",
  chainId: polygon.id,
  blockchain: Blockchain.POLYGON,
  chainName: polygon.name,
  exchange: {
    v2: "0x12b3897a36fDB436ddE2788C06Eff0ffD997066e",
    wrapper: "0xe90da87Ec96DF89590A5CD00c0183E69a36330a9",
  },
  blockExplorers: [
    {
      url: "https://polygonscan.com",
      icon: "/images/scanner.svg",
      adress: "https://polygonscan.com/address/${adrress}",
    },
  ],
  rpcUrls: [],
  privateRpcNodeSlug: "polygon-node",
  transferProxies: {
    nft: "0xd47e14DD9b98411754f722B4c4074e14752Ada7C",
    erc721Lazy: "0xDD28328257a2Cce3204332C747Cc350153937A1D",
    erc20: "0x49b4e47079d9b733B2227fa15f0762dBF707B263",
  },
  feeConfigUrl: FEE_CONFIG_URL,
  primaryCurrency: {
    id: toCurrencyId("POLYGON:0x0000000000000000000000000000000000000000"),
    symbol: "POL",
    name: "Polygon",
    decimals: 18,
  },
  wrappedCurrency: {
    id: toCurrencyId("POLYGON:0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270"),
    symbol: "WPOL",
    name: "Wrapped Polygon",
    decimals: 18,
  },
  addFundsLink: "http://localhost:3000/polygon/swap",
  hasStabilityProtocol: true,
  viem: polygon,
}

export const getPolygonConfig = (): StaticEthereumBlockchainConfig =>
  polygonConfig
